import { css } from '@emotion/react';

import { skeletonLoading } from 'src/styles/styles';

import { colors } from '../../../../styles/colors';
import { ZeeFontBold, ZeeFontRegular } from '../../../../styles/font';
import { MediaBP as MQ } from '../../../../styles/mediaQuery';
export const container = (overout: boolean) => css`
  ${!overout
    ? `flex-basis: calc(50% - 20px);
      margin: 10px;
      position:relative;
    `
    : ``}
  z-index:0;
  &:hover {
    z-index: 10;
  }
`;
export const contentItemPopUp = css`
  position: absolute;
  bottom: 0;
  padding: 10px 1px 5px 4px;
  background-color: ${colors.white};
  width: 100%;
  color: ${colors.black};
  opacity: 0;
  filter: blur(20px);
  text-align: left;
  transform: scale3d(0.01, 0.01, 0) translateZ(0) perspective(500px);
  transition: opacity 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93), transform 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93), filter 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93),
    background-color 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93),
    border-radius 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
  & h3 {
    font-size: 10px;
    font-weight: 700;
    line-height: 1.4em;
    ${ZeeFontBold(10, 20)}
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    color: ${colors.AccentDarkGrayColor};
  }
`;

export const thumbnailTitle = css`
  position: absolute;
  bottom: 0px;
  padding: 10px;
  ${ZeeFontRegular(14, 20)}
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;

export const contentItemCard = (overout: boolean, showHover?: boolean) => css`
  position: relative;
  height: 100%;
  width: 100%;
  ${!overout
    ? `flex-basis: calc(50% - 20px);
    `
    : ``}
  ${MQ.MediaLg} {
    ${showHover
      ? ''
      : ` &:hover {
        transition: all;
        ${
          overout
            ? `transform: scale3d(1.2, 1.2, 1) translateZ(0) perspective(500px);
              transition: transform 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
              transition-delay: 0.4s;
              backface-visibility: hidden;
              z-index: 100;
              top:0;
              bottom:0;
              `
            : ''
        }
        figure {
          :after {
            border: 8px solid ${colors.white};
            transition: border 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
            transition-delay: 0.4s;
            bottom: -7px;
            left: -7px;
            right: -7px;
            top: -7px;
          }
        }
        .popup-content {
          opacity: 1;
          filter: inherit;
          opacity: 0.99;
          transform: scaleX(1) translateZ(0) perspective(0);
          transition: opacity 0.25s ease-in,
            bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93),
            transform 0.25s ease-in,
            bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93),
            filter 0.25s ease-in,
            bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93),
            background-color 0.25s ease-in,
            bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93),
            border-radius 0.25s ease-in,
            bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
          transition-delay: 0.4s;
          z-index: 2;
        }
      }`}
  }
`;

export const skeletonContent = css`
  z-index: 0;
  overflow: hidden;
  background: ${colors.TemplateLoaderTrayBgDesktop};
  border-radius: 6px;
  ${skeletonLoading};
`;
export const skeletonCard = css`
  position: relative;
  width: 100%;
  height: 100%;
`;
export const skeletonWrapper = (type: string) => css`
  ${type === 'reco'
    ? `flex-basis: calc(50% - 20px);
      margin: 10px;
      position:relative;`
    : ''}
`;
